import { AppState } from "../app.state";

export const getUploadModalWindow = (state: AppState) => state.common.isOpen;

export const getValidationModalWindow = (state: AppState) => state.common.isValidModalOpen;
